// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"5ecc88ff","375":"5ecc88ff","474":"af8fb1b2","537":"5ecc88ff","890":"368bdab0"}[chunkId] + ".chunk.css";
};